<script setup lang="ts">
import { computed, toRef } from "vue";
import { AiHtmlInput } from "@/components/episto-ui/ai";
import StylePicker from "../StylePicker.vue";
import OptionSection from "./OptionSection.vue";
import { useCardLocalOptions } from "@/composables/useCardLocalOptions";

const props = defineProps({
  card: { type: Object, required: true },
});

const cardRef = toRef(props, "card");
const { localOptions, updateLocalOption } = useCardLocalOptions(cardRef);

const comment = computed({
  get: () => localOptions.value.comment || "",
  set: (val) => updateLocalOption("comment", val),
});

const commentStyle = computed({
  get: () => localOptions.value.comment_style || "info",
  set: (val) => updateLocalOption("comment_style", val),
});

const hasComment = computed(() => !!comment.value.replace(/<[^>]*>/g, "").trim());
</script>

<template>
  <OptionSection
    id="comment"
    title="Comment"
    :count="hasComment ? 1 : 0">
    <StylePicker v-model="commentStyle" />
    <AiHtmlInput
      :model-value="comment"
      placeholder="Add a comment..."
      @update:model-value="comment = $event" />
  </OptionSection>
</template>
